import React, { useState, useRef, useCallback } from "react";

import { base, formatTimeToAMPM } from "../../../constants/base";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const Info = ({ notificaion }) => {
  // SLIDER ARROWS
  const sliderRef = useRef();

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };
  // SLIDER ARROWS

  return (
    <div>
      <div className="profile-picture">
        {notificaion?.data?.sender?.role?.name === "corporate" ? (
          notificaion?.data?.request?.employee?.images && (
            <img
              src={
                base.imageUrl +
                notificaion?.data?.request?.employee?.images[0].path
              }
              alt=""
            />
          )
        ) : (
          <img
            src={base.imageUrl + notificaion?.data?.sender?.images[0].path}
            alt=""
          />
        )}
      </div>

      <h1>
        {notificaion?.data?.sender?.role?.name === "corporate"
          ? notificaion?.data?.request?.employee?.name
          : notificaion?.data?.sender?.name}
      </h1>

      <div className="about-text-box">
        <h2>About</h2>
        <p className="common-text">
          {notificaion?.data?.sender?.role?.name === "corporate"
            ? notificaion?.data?.request?.employee?.about
            : notificaion?.data?.sender?.about}
        </p>
        {notificaion?.data?.sender?.address && (
          <span className="d-block">
            <i className="fas fa-map-marker-alt"></i>{" "}
            {notificaion?.data?.sender?.address
              ? notificaion?.data?.sender?.address?.address
              : "No location set yet."}
          </span>
        )}
        <div className="container">
          <div className="row">
            <div className="col-md-6 ps-0">
              <h2 className="mt-0">User Reviews</h2>
            </div>

            {notificaion?.data?.sender_feedback?.length > 0 ? (
              <div className="col-md-6">
                <div className="popular-slider-arrow-box">
                  <i class="fa-solid fa-arrow-left" onClick={handlePrev}></i>
                  <i class="fa-solid fa-arrow-right" onClick={handleNext}></i>
                </div>
              </div>
            ) : (
              <div className="col-md-12 ps-0">
                <p className="common-text mb-0">
                  This User has No Reviews yet!
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="user-reviews-box-main">
          <Swiper
            slidesPerView={"4"}
            spaceBetween={0}
            navigation={false}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            modules={[Navigation]}
            onSlideChange={handleSlideChange}
            className="mySwiper"
            ref={sliderRef}
            breakpoints={{
              425: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              375: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              320: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              780: {
                slidesPerView: 2.3,
                spaceBetween: 0,
              },
              768: {
                slidesPerView: 2.3,
                spaceBetween: 0,
              },
              1280: {
                slidesPerView: 2.3,
                spaceBetween: 0,
              },
            }}
          >
            {notificaion?.data?.sender_feedback?.map((feedback, index) => {
              return (
                <SwiperSlide>
                  <div className="feedback-box-here" key={index}>
                    <div className="star-rating">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`star ${
                            star <= feedback?.stars || 0
                              ? "yellow-star"
                              : "grey-star"
                          }`}
                          data-value={star}
                        >
                          <i className="fa-solid fa-star"></i>
                        </span>
                      ))}
                      <span className="star">({feedback?.stars}.0)</span>
                    </div>

                    <p className="common-text mb-0">
                      <strong>"{feedback?.message}"</strong>
                    </p>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <span className="category-box">
          {notificaion?.data?.request?.service?.name}
        </span>{" "}
        <br />
        <span>
          {notificaion?.data?.request?.schedule?.day}:{" "}
          {notificaion?.data?.request?.schedule?.start_time &&
            formatTimeToAMPM(
              notificaion?.data?.request?.schedule?.start_time
            )}{" "}
          To{" "}
          {notificaion?.data?.request?.schedule?.end_time &&
            formatTimeToAMPM(
              notificaion?.data?.request?.schedule?.end_time
            )}{" "}
        </span>
        <br />
        {notificaion?.data?.request?.reason && (
          <div>
            <h2>Reason</h2>
            <span>{notificaion?.data?.request?.reason}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Info;
